<div class="task-event-history">
  <h3>Task Event History</h3>
  <p class="task-event-history__hint">Right-click a row to view its payload.</p>
  <wc-grid
    gridKey="eventHistory"
    [showQuickSearch]="false"
    [contextMenuItems]="menuItems"
    (contextMenuAction)="onGridAction($event)">
  </wc-grid>
</div>
